






import Vue from 'vue';

export default Vue.extend({
  name: 'Coin',
  props: ['value', 'type', 'hoverable', 'size']
});
// https://codepen.io/fr2/pen/wEKVrP
